module.exports = __webpack_public_path__ + "img/chinesecompany125.cc8bf69c.png";